// @ts-check

/**
 * @typedef {import('./StoreStrategy').StoreStrategy} StoreStrategy
 */

/**
 * @function PaycashStoreStrategy
 * @returns {StoreStrategy}
 */
function PaycashStoreStrategy() {
  async function getPayload() {
    return {};
  }

  return {
    getPayload,
  };
}

const paycashStoreStrategy = PaycashStoreStrategy();

export default paycashStoreStrategy;
